"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Title = _interopRequireWildcard(require("../primitive/Title"));
var _Label = require("../primitive/Label");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AttributeTile = function AttributeTile(_ref) {
  var title = _ref.title,
    label = _ref.label,
    icon = _ref.icon;
  return /*#__PURE__*/_react["default"].createElement(Inner, null, /*#__PURE__*/_react["default"].createElement(Content, null, icon && /*#__PURE__*/_react["default"].createElement(IconContainer, null, icon), /*#__PURE__*/_react["default"].createElement(TextContainer, null, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    variant: "small"
  }, title), label && /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    variant: "small"
  }, label))));
};
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "AttributeTile__IconContainer",
  componentId: "sc-1xqibzr-0"
})(["margin-right:1.6rem;@media (min-width:", "){display:flex;justify-content:center;align-items:flex-end;flex:1;margin-right:0.8rem;}g path{stroke-width:0.525;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueries.m;
});
var TextContainer = _styledComponents["default"].div.withConfig({
  displayName: "AttributeTile__TextContainer",
  componentId: "sc-1xqibzr-1"
})(["display:flex;flex-direction:column;@media (min-width:", "){justify-content:center;align-items:center;flex:1;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.m;
});
var StyledLabel = (0, _styledComponents["default"])(_Label.Label).withConfig({
  displayName: "AttributeTile__StyledLabel",
  componentId: "sc-1xqibzr-2"
})(["margin:0.2rem 0;font-size:1rem;color:", ";letter-spacing:0.1rem;line-height:2rem;font-weight:700;@media (min-width:", "){text-align:center;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.neutral['40'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.mediaQueries.m;
});
var Content = _styledComponents["default"].div.withConfig({
  displayName: "AttributeTile__Content",
  componentId: "sc-1xqibzr-3"
})(["display:flex;align-items:center;@media (min-width:", "){position:absolute;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:column;max-width:none;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueries.m;
});
var Inner = _styledComponents["default"].div.withConfig({
  displayName: "AttributeTile__Inner",
  componentId: "sc-1xqibzr-4"
})(["width:100%;text-align:left;position:relative;height:0;@media (min-width:", "){padding-top:123%;box-shadow:0 16px 24px 0 rgba(59,118,160,0.03),0 24px 80px 0 rgba(59,118,160,0.05);display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;}", "{font-weight:200;}", "{font-family:Manrope,sans-serif;text-transform:uppercase;color:", ";}", " img{display:inline-block;color:", ";width:3rem;height:3rem;@media screen and (min-width:", "){width:4rem;height:4rem;}@media (min-width:", "){width:5rem;height:5rem;}@media screen and (min-width:", "){width:6rem;height:6rem;}@media screen and (min-width:", "){width:7rem;height:7rem;}}:first-child:last-child,:last-child:nth-child(2),:nth-last-child(2):first-child{", "{line-height:3rem;}}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.mediaQueries.m;
}, _Title.TitleInner, _Label.Label, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.neutral['30'];
}, IconContainer, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.neutral['70'];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.mediaQueries.s;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.mediaQueries.m;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.mediaQueries.l;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.mediaQueries.xl;
}, _Title.TitleInner);
var _default = exports["default"] = AttributeTile;
//# sourceMappingURL=AttributeTile.js.map